export default "/images/user-icon.svg?f419c5e1e7b8448c80ef5fcb197f9d98";